/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Audit_EmptyInputs */



/**
* | output |
* | --- |
* | "Nothing recorded for this member in this period." |
*
* @param {Member_Audit_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_audit_empty = /** @type {((inputs?: Member_Audit_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Audit_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für dieses Mitglied wurde in diesem Zeitraum nichts aufgezeichnet.")
	return /** @type {LocalizedString} */ ("Nothing recorded for this member in this period.")
});